<template>
  <div class="compare-count" :class="{'align-left': layout === 'fixed'}" v-if="authenticated">
    <div class="inline-count-badge" v-if="layout === 'inline'">
      {{compareCount}}
    </div>
    <div class="compare-item-list" v-else-if="layout === 'fixed'">
      <div class="status-item" v-for="item in this.options" :key="item.id">
        <div class="status-item-img">
          <img :src="getOptionImgSrc(item.imgSrc)" style="maxWidth: 55px; maxHeight: 55px;" />
        </div>
        <div class="status-item-name">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="fab-count-badge" v-else-if="layout === 'fab'">
      {{compareCount}}
    </div>
  </div>
</template>

<script>
  import Constants from '../../constants.json'

  import * as firebase from 'firebase/app'
  // Load the auth feature into the firebase namespace.
  import 'firebase/auth'
  import 'firebase/firestore'

  import axios from 'axios'

  export default {
    name: 'CompareStatus',
    data () {
      return {
        authenticated: false,
        appId: null,
        taxon: null,
        originDomain: null,
        containerId: null,
        embedderId: null,
        layout: null,
        working: false,
        options: [],
        authUnsubscribeCallack: null,
        dataUnSubscribeCallback: null
      }
    },
    computed: {
      compareCount () {
        return this.options.length
      }
    },
    mounted: async function () {
      if (this.authUnsubscribeCallack) {
        this.authUnsubscribeCallack()
        this.authUnsubscribeCallack = null
      }
      this.authUnsubscribeCallack = firebase.auth().onAuthStateChanged(() => {
        this.initAuthedState()
      })
    },
    beforeDestroy: function () {
      // Unsubscribe
      this.unsbscribeFromDataListeners()

      if (this.authUnsubscribeCallack) {
        this.authUnsubscribeCallack()
        this.authUnsubscribeCallack = null
      }
    },
    methods:  {
      initAuthedState: async function () {
        this.authenticated = false

        // Unsubscribe from listening to data in case there is already a subscription
        this.unsbscribeFromDataListeners()

        const currentUser = firebase.auth().currentUser
        if (currentUser) {
          console.log(`Have a user ${currentUser.uid}`)
          this.authenticated = true

        } else {
          console.log('DCDLY - Invalid authentication state')
          // TODO auth flow for creating an anonymous user
        }

        if (this.authenticated) {

          // Load query string params taxon, href and appId
          this.taxon = this.$route.query['taxon'] || null;
          this.appId = this.$route.query['appId'] || null;
          this.originDomain = this.$route.query['origin'] || null;
          this.containerId = this.$route.query['containerId'] || null; // For updating the container styling
          this.embedderId = this.$route.query['embedderId'] || null; // For sending and receibing messages
          this.layout = this.$route.query['layout'] || 'inline';

          // TODO more Validation
          if (typeof this.taxon !== 'string' ||
              typeof this.appId !== 'string' ||
              typeof this.originDomain !== 'string' ||
              typeof this.containerId !== 'string' ||
              typeof this.embedderId !== 'string' ||
              typeof this.layout !== 'string'
            ) {
              return
            }


          // window.parent.postMessage({taxon: this.taxon, appId: this.appId, windowId: this.embedderId, action: 'init'}, this.originDomain)
          //
          //
          // // Listen for messages from those who receive the init
          // window.addEventListener("message", (event) => {
          //   console.log(`Possible toggle event listener fired in Compare status plugin ${event.origin}`)
          // }, false);

          // if (this.originDomain) {
          //   // Temp add port for testing
          //   this.originDomain = `http://${this.originDomain}:8080`
          // }

          // TODO get the decisionId associated with this app / taxon

          const decisionId = await this.getDecisionId()

          console.log('Status plugin has loaded decisoin id = ' + decisionId)

          if (decisionId && !this.dataUnSubscribeCallback) {

            // TODO consider conume message and post message instead of onSnapshot
            this.dataUnSubscribeCallback = firebase.firestore().collection("decisions").doc(decisionId).collection("options").where("owner", "==", currentUser.uid)
              .onSnapshot((snapshot) => {
                  snapshot.docChanges().forEach((change) => {
                    const docData = change.doc.data()
                    const itemIndex = this.options.findIndex(item => item.url === docData.url)
                      if (change.type === "added") {
                          // this.options.push(doc.data().name);
                          // console.log("Added option: ", change.doc.data());
                          if (docData.comparing && itemIndex === -1) {
                            this.options.push({url: docData.url, name: docData.name, imgSrc: docData.imgSrc});
                          }
                      }
                      if (change.type === "modified") {
                          // console.log("Modified option: ", change.doc.data());
                          if (docData.comparing && itemIndex === -1) {
                            this.options.push({url: docData.url, name: docData.name, imgSrc: docData.imgSrc});
                          } else if (!docData.comparing && itemIndex > -1) {
                            this.options.splice(itemIndex, 1);
                          }

                      }
                      if (change.type === "removed") {
                          // console.log("Removed option: ", change.doc.data());
                          if (itemIndex > -1) {
                            this.options.splice(itemIndex, 1);
                          }
                      }
                  });

                  window.parent.postMessage({taxon: this.taxon, appId: this.appId, containerId: this.containerId, compareCount: this.options.length, action: 'update'}, this.originDomain)
              });
          }
        }
      },
      getDecisionId: async function () {
        if (!this.authenticated) {
          return
        }

        let decisionId = null
        this.working = true
        // const tempDecisionKey = `${this.appId}-${this.taxon}` // One decision board per app/taxon pair
        const payload = {taxon: this.taxon, appId: this.appId}
        const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
        const decisionIdURL = `${Constants.API_BASE_PATH}/tempdecisions/id`

        const res = await axios.post(decisionIdURL, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        })

        if (res && res.status === 200 && res.data) {
          decisionId = res.data.decisionId
        }

        return decisionId
      },
      unsbscribeFromDataListeners: function () {
        if (this.dataUnSubscribeCallback) {
          this.dataUnSubscribeCallback()
          // Also trigger a message to update the compare count for any subscribers to this window
          if (this.taxon && this.appId && this.containerId && this.originDomain) {
           window.parent.postMessage({taxon: this.taxon, appId: this.appId, containerId: this.containerId, compareCount: 0}, this.originDomain)
          }

          this.dataUnSubscribeCallback = null
        }
      },
      getOptionImgSrc: function (imgUrl) {
        let res = imgUrl || `${Constants.SCREENSHOT_CDN}/unknownimage.png`
        // if (res.indexOf('https:') !== 0) {
        //    res = `${Constants.SCREENSHOT_CDN}/notsecureimage.png`
        // }
        return res
      }
    }
  }
</script>

<style lang="scss">
.compare-count {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212121;

  &.align-left {
    justify-content: flex-start;
  }

  .inline-count-badge {
    width: 24px;
    height: 24px;
    background: #DDD;
    border-radius: 50%;
    margin-top: 3px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .compare-item-list {
    display: flex;
    align-items: center;
    height: 80px;

    .status-item {
      padding: 10px;
      border-right: 1px dashed #CCC;
      background: white;
      padding: 0 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;

      .status-item-name {
        color: #212121;
        font-size: 11px;
        max-height: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>
